import { IxField } from './IxField.js';

customElements.define('ix-field', IxField);
